import axios from 'axios';
import querystring from 'querystring';
import {
    FETCH_LANG_CUSTOMER_SUCCESS,
} from '../constants/ActionTypes';

export const fetchLangCustomerSuccess = data => {
    return {
        type: FETCH_LANG_CUSTOMER_SUCCESS,
        payload: data
    }
}

export const fetchLangCustomer = (payload) => {
    const { company, language } = payload;
    let queryString = querystring.stringify({ company, language });
    
    return dispatch => {
        const url = `${process.env.REACT_APP_API_URL}language/customer?${queryString}`;
        axios.get(url, {headers: {"Authorization": `Bearer ${localStorage.getItem('x-access-token')}`}})
        .then(response => {
            let data = {
                newCustomer: response.data.newCustomer,
                prospect: response.data.prospect,
                reEntry: response.data.reEntry,
                target: response.data.target,
                activeCustomer: response.data.activeCustomer,
                inactive: response.data.inactive,
                customerBuyAndNot: response.data.customerBuyAndNot,
                customerBuyAmount: response.data.customerBuyAmount,
                customerNotBuyAmount: response.data.customerNotBuyAmount,
                customerAllAmount: response.data.customerAllAmount,
                customerGroup: response.data.customerGroup,
                customerInfo: response.data.customerInfo,
                customerBuyProduct: response.data.customerBuyProduct,
                customerNotBuyProduct: response.data.customerNotBuyProduct,
                customerName: response.data.customerName,
                customerReceivableAging: response.data.customerReceivableAging,
                customerReceivableAgingInfo: response.data.customerReceivableAgingInfo,
                customerReceivableAgingNotOver: response.data.customerReceivableAgingNotOver,
                customerReceivableAgingOver: response.data.customerReceivableAgingOver,
                customerReceivable: response.data.customerReceivable,
                customerOverDue: response.data.customerOverDue,
                customerDue: response.data.customerDue,
                customerNotDue: response.data.customerNotDue,
                customerCode: response.data.customerCode,
            }
            
            dispatch(fetchLangCustomerSuccess(data));
        })
        .catch(error => {
            //dispatch(showKpiMessage(error.response));
        })
    }
}